exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 1024px) {\n  .secondary-show {\n    display: block; }\n  .secondary-hide {\n    display: none; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/components/secondary-sidebar/secondary-sidebar.component.scss
// module id = ../../../../../src/app/@hornbillfx/components/secondary-sidebar/secondary-sidebar.component.scss
// module chunks = main